// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"608104b451f6553250b6","678":"61c81787da3326664875","883":"912ab4834bdf45bc532e"}[chunkId] + ".js";
};